module.exports = __webpack_public_path__ + "img/L.68f19038.jpg";